import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import Modal from 'components/layout/modal';
import events from 'lib/events';
import Loader from 'components/loader';
import Header from 'components/layout/header';
import LayoutSelect from 'components/forms/layoutSelect';
import {
  trashBinRecordTypesFormat,
  trashBinTimeFramesFormat,
  trashBinRecordTypes,
  truBlueStatus,
  chemicalBaseTypeNames,
} from 'helpers/constants';
import phoneFormat from 'util/phoneformat';
import TrashBinApi from 'api/trashBin.jsx';
import {systemOptionsTags} from 'helpers/dataHelpers';
import {trublueMemberIDEnabled} from 'features';


class CustomerTrashBinRecord extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    record: PropTypes.object.isRequired,
    dealer: PropTypes.object.isRequired,
  };

  getContactSection = () => {
    const {record} = this.props;
    let contacts = record.customer.customerContacts
      .filter(cc => !cc.deleted)
      .map(contact => {
        let contactName;

        if (contact.nameFirst || contact.nameLast) {
          contactName = (contact.nameFirst || '') + ' ' + (contact.nameLast || '');
          contactName += contact.organization ? ' | ' + contact.organization : '';
        } else {
          contactName = contact.organization;
        }

        return (
          <div className='contact-summary' key={contact.ID}>
            <div className='contact-summary__content'>
              <p className='contact-summary__name'>{contactName}</p>
              <p className='contact-summary__details'>
                {contact.email ?
                  <div>
                    <label>
                      <FormattedMessage id="general.email" />:
                    </label>
                    <span className="value">{contact.email}</span>
                  </div> :
                 null}
                {contact.homePhone ?
                  <div>
                    <label>
                      <FormattedMessage id="general.phone.number" />
                      <span className="dim n">
                          &nbsp;(
                        <FormattedMessage id="general.primary" />):
                      </span>
                    </label>
                    <span className="value">{phoneFormat(contact.homePhone)}</span>
                  </div> :
                 null}
                {contact.workPhone ?
                  <div>
                    <label>
                      <FormattedMessage id="general.phone.number" />
                      <span className="dim n">
                          &nbsp;(
                        <FormattedMessage id="general.alternate" />):
                      </span>
                    </label>
                    <span className="value">{phoneFormat(contact.workPhone)}</span>
                  </div> :
                 null}
                {contact.mobilePhone ?
                  <div>
                    <label>
                      <FormattedMessage id="general.phone.number" />
                      <span className="dim n">
                          &nbsp;(
                        <FormattedMessage id="general.alternate" />):
                      </span>
                    </label>
                    <span className="value">{phoneFormat(contact.mobilePhone)}</span>
                  </div> :
                 null}
              </p>
            </div>
          </div>);
      });

    if(contacts.length) {
      return <div style={{marginTop: '20px'}}>
        <h4 className='trashbin-record-content__heading'><FormattedMessage id="general.contacts"/></h4>
        {contacts}
      </div>;
    }
    return  null;
  };

  getPoolSection = () => {
    const {record, dealer} = this.props;
    const {formatMessage} = this.props.intl;

    let pools = record.customer.pools
      .filter(p => !p.deleted)
      .map(pool => {
        let poolLocation = systemOptionsTags[pool.typeID].location;
        let poolFinish = systemOptionsTags[pool.typeID].finish;
        const isCanada = dealer && dealer.country && dealer.country.toLowerCase() === 'ca';
        let volume = pool.volume.format(0, 3) + ' ' + formatMessage({id: isCanada ? 'quick-calcs.volume.litres' : 'quick-calcs.volume.gals'});

        return <div className='system-summary' key={pool.ID}>
          <div className='system-summary__header'>
            <p>
              {pool.softSoakTRIO ? 'Trio ' : null}
              {chemicalBaseTypeNames(
                pool.typeID,
                pool.sanitizerType || 2,
                formatMessage
              )}
            </p>
            {pool.nickName ?
              <p>
                <label>
                  <FormattedMessage id="system.details.system.nickname" />
                </label>
                <span className="value">{pool.nickName}</span>
              </p> :
                 null}
            <p>
              {poolLocation[pool.location] ? formatMessage({id: poolLocation[pool.location]}) : formatMessage({id: 'general.none'})}
              <span className='separator'> | </span>
              {volume}
              <span className='separator'> | </span>
              {poolFinish[pool.finish] ? formatMessage({id: poolFinish[pool.finish]}) : formatMessage({id: 'general.none'})}.
            </p>
            <p>
              <label>
                <FormattedMessage id="general.last.analysis.date" />:
              </label>
              <span className="value">{pool.prevAnalysisDate ? moment(pool.prevAnalysisDate).format('ll') : formatMessage({id: 'general.never'})}</span>
            </p>
          </div>
        </div>;
      });

    if(pools.length) {
      return <div style={{marginTop: '20px'}}>
        <h4 className='trashbin-record-content__heading'><FormattedMessage id="general.systems"/></h4>
        {pools}
      </div>;
    }

    return null;
  };

  render() {
    const {record, dealer} = this.props;

    return (
      <div className="trashbin-record-content">
        <h4 className='trashbin-record-content__heading'><FormattedMessage id="general.account"/></h4>
        <div>
          <label>
            <strong>
              <FormattedMessage id="general.alexid"/>:
            </strong>
            <span className="value">{record.customer.accountNum}</span>
          </label>
        </div>
        <div>
          {record.customer.POSVendorID ?
            <label>
              <strong>
                <FormattedMessage id="general.posid" />:
              </strong>
              <span className="value">{record.customer.POSVendorID}</span>
            </label> :
         null}
        </div>
        <div>
          {trublueMemberIDEnabled && record.customer.truBlueMemberID &&
        record.customer.truBlueStatus === truBlueStatus.Active ?
          <label>
            <strong>
              <FormattedMessage id="general.trublue.memberID" />:
            </strong>
            <span className="value">{record.customer.truBlueMemberID}</span>
          </label> :
         null}
        </div>
        <div>
          <label>
            <strong>
              <FormattedMessage id="general.address"/>:
            </strong>
            <span className="value">
              {`${record.customer.address1} ${record.customer.address2 || ''} | ${
            record.customer.city || dealer.city || '--'
          } | ${record.customer.state || dealer.state} | ${
            record.customer.zip || dealer.zip || '--'
          }`} </span>
          </label>
        </div>
        <div>{this.getContactSection()}</div>
        <div>{this.getPoolSection()}</div>
      </div>
    );
  }
}

export default injectIntl(CustomerTrashBinRecord);
